import React from 'react';
import { useCallback } from 'react';
import CellRadio from './CellRadio';
import CellCard from './CellCard';
import { ICellRadioGroup } from './types';

const CellRadioGroup = ({
  options,
  value,
  onChange,
  disabled,
  inputProps,
  ...rest
}: ICellRadioGroup) => {
  const handleChange = useCallback(
    (v: string | number | null) => {
      if (v === value || disabled) {
        return;
      }
      onChange && onChange(v);
    },
    [disabled, onChange, value],
  );

  return (
    <CellCard {...rest}>
      {options.map((item) => (
        <CellRadio
          inner
          key={item.value}
          value={item.value}
          title={item.title}
          description={item.description}
          checked={item.value === value}
          disabled={disabled || item.disabled}
          onClick={handleChange}
          {...inputProps}
        />
      ))}
    </CellCard>
  );
};

export default CellRadioGroup;
